import e, { Component as t } from "react";
import n from "prop-types";

function r(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}

function a(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}

function o(e) {
  return (o = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  })(e);
}

function i(e, t) {
  return (i = Object.setPrototypeOf || function (e, t) {
    return e.__proto__ = t, e;
  })(e, t);
}

function c(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}

var s = "style_captchaContainer__LdFYB",
    l = "style_retryButton__2gxEO";
!function (e, t) {
  void 0 === t && (t = {});
  var n = t.insertAt;

  if (e && "undefined" != typeof document) {
    var r = document.head || document.getElementsByTagName("head")[0],
        a = document.createElement("style");
    a.type = "text/css", "top" === n && r.firstChild ? r.insertBefore(a, r.firstChild) : r.appendChild(a), a.styleSheet ? a.styleSheet.cssText = e : a.appendChild(document.createTextNode(e));
  }
}(".style_captchaContainer__LdFYB {\n  display: flex;\n  align-items: center;\n}\n\n.style_retryButton__2gxEO {\n  border: none;\n  margin: 0 0 0 16px;\n  padding: 0;\n  width: auto;\n  overflow: visible;\n  background: transparent;\n  color: inherit;\n  font: inherit;\n  line-height: normal;\n  -webkit-font-smoothing: inherit;\n  -moz-osx-font-smoothing: inherit;\n  -webkit-appearance: none;\n  outline: none;\n  text-align: inherit;\n}\n", {
  insertAt: "top"
});

var u = function (n) {
  function s(t) {
    var n, r, i;
    return function (e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }(this, s), r = this, i = o(s).call(this, t), n = !i || "object" != typeof i && "function" != typeof i ? c(r) : i, a(c(n), "generateCode", function () {
      for (var e = n.props, t = e.chars, r = e.charsCount, a = [], o = 0; o < r; o += 1) {
        var i = Math.ceil(Math.random() * t.length);
        t[i] && -1 === a.indexOf(t[i]) ? a.push(t[i]) : o -= 1;
      }

      return a.join("");
    }), a(c(n), "resetCaptcha", function (e) {
      e.preventDefault(), n.generateCaptcha();
    }), a(c(n), "generateCaptcha", function () {
      var e = n.props,
          t = e.width,
          r = e.height,
          a = e.fontSize,
          o = e.captchaCode,
          i = e.backgroundColor,
          c = e.fontFamily,
          s = e.fontColor;
      n.captchaCode = n.generateCode();
      var l = n.canvasRef.current.getContext("2d");
      l.fillStyle = i, l.fillRect(0, 0, t, r), l.font = "".concat(a, "px ").concat(c), l.textAlign = "center", l.textBaseline = "middle", l.fillStyle = s, l.fillText(n.captchaCode.split("").join(" "), t / 2, r / 2), o(n.captchaCode);
    }), n.canvasRef = e.createRef(), n.captchaCode = "", n;
  }

  var l, u, h;
  return function (e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        writable: !0,
        configurable: !0
      }
    }), t && i(e, t);
  }(s, t), l = s, (u = [{
    key: "componentDidMount",
    value: function value() {
      this.generateCaptcha();
    }
  }, {
    key: "render",
    value: function value() {
      var t = this.props,
          n = t.width,
          r = t.height,
          a = t.retryIcon,
          o = t.containerClassName,
          i = t.captchaClassName,
          c = t.retryButtonClassName,
          s = t.retryImgClassName,
          l = t.retry,
          u = t.retryIconSize;
      return e.createElement("div", {
        className: o
      }, e.createElement("canvas", {
        width: n,
        height: r,
        ref: this.canvasRef,
        style: {
          pointerEvents: "none"
        },
        className: i
      }), l && e.createElement("button", {
        onClick: this.resetCaptcha,
        id: "retryButton",
        className: c
      }, e.createElement("img", {
        src: a,
        alt: "Re-new captcha",
        className: s,
        width: u,
        height: u
      })));
    }
  }]) && r(l.prototype, u), h && r(l, h), s;
}();

u.defaultProps = {
  width: 100,
  height: 40,
  fontSize: 22,
  fontFamily: "Arial, Tahoma",
  fontColor: "#000",
  chars: "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789",
  charsCount: 4,
  backgroundColor: "#F2F2F2",
  retry: !0,
  retryIcon: "https://cdn.jsdelivr.net/npm/react-client-captcha/dist/retry.svg",
  retryIconSize: 24,
  retryButtonClassName: l,
  retryImgClassName: "",
  containerClassName: s,
  captchaClassName: ""
}, u.propTypes = {
  width: n.number.isRequired,
  height: n.number.isRequired,
  fontSize: n.number,
  fontFamily: n.string,
  fontColor: n.string,
  chars: n.string,
  charsCount: n.number,
  captchaCode: n.func.isRequired,
  backgroundColor: n.string,
  retry: n.bool,
  retryIcon: n.string,
  retryIconSize: n.number,
  retryButtonClassName: n.string,
  retryImgClassName: n.string,
  containerClassName: n.string,
  captchaClassName: n.string
};
export default u;